import { render, staticRenderFns } from "./FloatingChat.vue?vue&type=template&id=997f45ac&scoped=true&"
import script from "./FloatingChat.vue?vue&type=script&lang=js&"
export * from "./FloatingChat.vue?vue&type=script&lang=js&"
import style0 from "./FloatingChat.vue?vue&type=style&index=0&id=997f45ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997f45ac",
  null
  
)

export default component.exports